import { useState } from 'react'
import Box from '@mui/material/Box'
import SubMenu from './SubMenu'
import { MenuItemLink, useSidebarState } from 'react-admin'
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart'
import StarIcon from '@mui/icons-material/Star'
import ListIcon from '@mui/icons-material/List'
import RequestIcon from '@mui/icons-material/RequestPage'
import PaidIcon from '@mui/icons-material/Paid'
import ReceiptIcon from '@mui/icons-material/Receipt'
import InventoryIcon from '@mui/icons-material/Inventory'
import PendingActionsIcon from '@mui/icons-material/PendingActions'
import LocalOfferIcon from '@mui/icons-material/LocalOffer'
import LocalActivityIcon from '@mui/icons-material/LocalActivity'
import HomeIcon from '@mui/icons-material/Home'
import PestControlIcon from '@mui/icons-material/PestControl'
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb'
import MailIcon from '@mui/icons-material/Mail'
import HelpIcon from '@mui/icons-material/Help'
import LocalShippingIcon from '@mui/icons-material/LocalShipping'
import ScienceIcon from '@mui/icons-material/Science'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail'
import ErrorIcon from '@mui/icons-material/Error'
import VisibilityIcon from '@mui/icons-material/Visibility'
import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import NotificationsIcon from '@mui/icons-material/Notifications'
import SettingsIcon from '@mui/icons-material/Settings'
import HistoryIcon from '@mui/icons-material/History'
import BusinessIcon from '@mui/icons-material/Business'
import LocationOnIcon from '@mui/icons-material/LocationOn'
import DescriptionIcon from '@mui/icons-material/Description'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import { Divider } from '@mui/material'

const Menu = () => {
  const [state, setState] = useState({
    menuOrders: false,
    menuKits: true,
    menuCoupons: false,
    menuProviders: false,
    menuNotifications: false,
    menuRequisitions: false,
    providerAccess: false,
    kitRequests: false,
    providerGroups: false,
    menuSettings: false,
  })

  const [open] = useSidebarState()

  const handleToggle = (menu) => {
    setState((state) => ({ ...state, [menu]: !state[menu] }))
  }

  return (
    <Box
      sx={{
        width: open ? '100%' : 50,
        marginTop: 1,
        marginBottom: 1,
        transition: (theme) =>
          theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <SubMenu handleToggle={() => handleToggle('menuOrders')} isOpen={state.menuOrders} name="Orders" icon={<ShoppingCartIcon />}>
        <MenuItemLink to="/orders" state={{ _scrollToTop: true }} primaryText={`All`} leftIcon={<ListIcon />} />
        <MenuItemLink to="/orders/status/new" state={{ _scrollToTop: true }} primaryText={`New`} leftIcon={<StarIcon />} />
        <MenuItemLink
          to="/orders/status/kitsAssignedReadyToShip"
          state={{ _scrollToTop: true }}
          primaryText={`Ready to Ship`}
          leftIcon={<InventoryIcon />}
        />
        <MenuItemLink
          to="/orders/status/shippingLabelPurchased"
          state={{ _scrollToTop: true }}
          primaryText={`Shipping Label Purchased`}
          leftIcon={<LocalOfferIcon />}
        />
        <MenuItemLink to="/orders/status/shipped" state={{ _scrollToTop: true }} primaryText={`Shipped`} leftIcon={<HomeIcon />} />
        <MenuItemLink
          to="/orders/status/duplicate"
          state={{ _scrollToTop: true }}
          primaryText={`Duplicates`}
          leftIcon={<PestControlIcon />}
        />
        <MenuItemLink
          to="/orders/status/canceled"
          state={{ _scrollToTop: true }}
          primaryText={`Canceled`}
          leftIcon={<DoNotDisturbIcon />}
        />
        <MenuItemLink
          to="/orders/status/manualReview"
          state={{ _scrollToTop: true }}
          primaryText={`Manual Review`}
          leftIcon={<VisibilityIcon />}
        />
        <MenuItemLink to="/orders/status/error" state={{ _scrollToTop: true }} primaryText={`Error`} leftIcon={<ErrorIcon />} />
      </SubMenu>
      <Divider />
      <SubMenu handleToggle={() => handleToggle('menuKits')} isOpen={state.menuKits} name="Kits" icon={<InventoryIcon />}>
        <MenuItemLink to="/kits" state={{ _scrollToTop: true }} primaryText={`All`} leftIcon={<ListIcon />} />
        <MenuItemLink to="/kits/status/new" state={{ _scrollToTop: true }} primaryText={`New`} leftIcon={<StarIcon />} />
        <MenuItemLink
          to="/kits/status/inboundShippingLabelPurchased"
          state={{ _scrollToTop: true }}
          primaryText={`Ready to Ship`}
          leftIcon={<MailIcon />}
        />
        <MenuItemLink
          to="/kits/status/unregisteredPrepaid"
          state={{ _scrollToTop: true }}
          primaryText={`Unregistered Prepaid`}
          leftIcon={<HelpIcon />}
        />
        <MenuItemLink
          to="/kits/status/outToPatient"
          state={{ _scrollToTop: true }}
          primaryText={`Out to Patient`}
          leftIcon={<HomeIcon />}
        />
        <MenuItemLink
          to="/kits/status/shippedByPatient"
          state={{ _scrollToTop: true }}
          primaryText={`Shipped by Patient`}
          leftIcon={<LocalShippingIcon />}
        />
        <MenuItemLink
          to="/kits/status/deliveredToLab"
          state={{ _scrollToTop: true }}
          primaryText={`Delivered to Lab`}
          leftIcon={<ScienceIcon />}
        />
        <MenuItemLink
          to="/kits/status/pendingConfirmation"
          state={{ _scrollToTop: true }}
          primaryText={`Pending Confirmation`}
          leftIcon={<PendingActionsIcon />}
        />
        <MenuItemLink
          to="/kits/status/testComplete"
          state={{ _scrollToTop: true }}
          primaryText={`Test Complete`}
          leftIcon={<CheckCircleIcon />}
        />
        <MenuItemLink
          to="/kits/status/notifyComplete"
          state={{ _scrollToTop: true }}
          primaryText={`Notify Complete`}
          leftIcon={<AlternateEmailIcon />}
        />
        <MenuItemLink to="/kits/status/error" state={{ _scrollToTop: true }} primaryText={`Error`} leftIcon={<ErrorIcon />} />
        <MenuItemLink
          to="/kits/status/manualReview"
          state={{ _scrollToTop: true }}
          primaryText={`Manual Review`}
          leftIcon={<VisibilityIcon />}
        />
      </SubMenu>
      <Divider />
      <SubMenu
        handleToggle={() => handleToggle('menuCoupons')}
        isOpen={state.menuCoupons}
        name="Coupons"
        icon={<LocalActivityIcon />}
      >
        <MenuItemLink to="/coupons" state={{ _scrollToTop: true }} primaryText={'Coupons'} leftIcon={<LocalActivityIcon />} />
      </SubMenu>
      <Divider />
      <SubMenu
        handleToggle={() => handleToggle('menuProviders')}
        isOpen={state.menuProviders}
        name="Providers"
        icon={<AccountCircleIcon />}
      >
        <MenuItemLink to="/providers" state={{ _scrollToTop: true }} primaryText={'All'} leftIcon={<AccountCircleIcon />} />
      </SubMenu>
      <Divider />
      <SubMenu
        handleToggle={() => handleToggle('menuNotifications')}
        isOpen={state.menuNotifications}
        name="Notifications"
        icon={<NotificationsIcon />}
      >
        <MenuItemLink
          to="/notifications"
          state={{ _scrollToTop: true }}
          primaryText={'Notifications'}
          leftIcon={<NotificationsIcon />}
        />
      </SubMenu>
      <Divider />
      <SubMenu
        handleToggle={() => handleToggle('menuRequisitions')}
        isOpen={state.menuRequisitions}
        name="Requisitions Due"
        icon={<NotificationsIcon />}
      >
        <MenuItemLink
          to="/requisitions/outToPatient"
          state={{ _scrollToTop: true }}
          primaryText={'Out To Patient'}
          leftIcon={<AccountCircleIcon />}
        />
        <MenuItemLink
          to="/requisitions/shippedByPatient"
          state={{ _scrollToTop: true }}
          primaryText={'Shipped By Patient'}
          leftIcon={<AccountCircleIcon />}
        />
        <MenuItemLink
          to="/requisitions/deliveredToLab"
          state={{ _scrollToTop: true }}
          primaryText={'Delivered To Lab'}
          leftIcon={<AccountCircleIcon />}
        />
        <MenuItemLink
          to="/requisitions/testComplete"
          state={{ _scrollToTop: true }}
          primaryText={'Test Complete'}
          leftIcon={<AccountCircleIcon />}
        />
        <MenuItemLink
          to="/requisitions/notifyComplete"
          state={{ _scrollToTop: true }}
          primaryText={'Notify Complete'}
          leftIcon={<AccountCircleIcon />}
        />
        <MenuItemLink
          to="/requisitions/error"
          state={{ _scrollToTop: true }}
          primaryText={'Error'}
          leftIcon={<AccountCircleIcon />}
        />
      </SubMenu>
      <Divider />
      <SubMenu
        handleToggle={() => handleToggle('providerAccess')}
        isOpen={state.providerAccess}
        name="Provider Access"
      // icon={<NotificationsIcon />}
      >
        <MenuItemLink
          to="/provider-access"
          state={{ _scrollToTop: true }}
          primaryText={'Provider Access'}
          leftIcon={<AdminPanelSettingsIcon />}
        />
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle('kitRequests')}
        isOpen={state.kitRequests}
        name="Kit Requests"
        icon={<RequestIcon />}
      >
        <MenuItemLink to="/kit-requests" state={{ _scrollToTop: true }} primaryText={'All'} leftIcon={<ListIcon />} />
        <MenuItemLink to="/kit-requests/status/pending" state={{ _scrollToTop: true }} primaryText={'Pending'} leftIcon={<PendingActionsIcon />} />
        <MenuItemLink to="/kit-requests/status/failedToCreate" state={{ _scrollToTop: true }} primaryText={'Failed to Create'} leftIcon={<ErrorIcon />} />
        <MenuItemLink to="/kit-requests/status/convertedToOrder" state={{ _scrollToTop: true }} primaryText={'Order Created'} leftIcon={<CheckCircleIcon />} />
        <MenuItemLink to="/kit-requests/status/partiallyInvoiced" state={{ _scrollToTop: true }} primaryText={'Partially Invoiced'} leftIcon={<ReceiptIcon />} />
        <MenuItemLink to="/kit-requests/status/fullyInvoiced" state={{ _scrollToTop: true }} primaryText={'Fully Invoiced'} leftIcon={<PaidIcon />} />
        <MenuItemLink to="/kit-requests/status/canceled" state={{ _scrollToTop: true }} primaryText={'Canceled'} leftIcon={<DoNotDisturbIcon />} />
        <MenuItemLink to="/kit-requests-invoicing" state={{ _scrollToTop: true }} primaryText={'Invoicing'} leftIcon={<ReceiptLongIcon />} />
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle('providerGroups')}
        isOpen={state.providerGroups}
        name="Provider Groups"
        icon={<BusinessIcon />}
      >
        <MenuItemLink
          to="/provider-groups"
          state={{ _scrollToTop: true }}
          primaryText={'Provider Groups'}
          leftIcon={<BusinessIcon />}
        />
        <MenuItemLink
          to="/provider-locations"
          state={{ _scrollToTop: true }}
          primaryText={'Provider Locations'}
          leftIcon={<LocationOnIcon />}
        />
        <MenuItemLink
          to="/provider-contracts"
          state={{ _scrollToTop: true }}
          primaryText={'Provider Contracts'}
          leftIcon={<DescriptionIcon />}
        />
      </SubMenu>
      <SubMenu
        handleToggle={() => handleToggle('menuSettings')}
        isOpen={state.menuSettings}
        name="Settings"
        icon={<SettingsIcon />}
      >
        <MenuItemLink
          to="/notification-settings"
          state={{ _scrollToTop: true }}
          primaryText={'Settings'}
          leftIcon={<SettingsIcon />}
        />
        <MenuItemLink
          to="/provider-notification-logs"
          state={{ _scrollToTop: true }}
          primaryText={'Notifications Log'}
          leftIcon={<HistoryIcon />}
        />
      </SubMenu>
    </Box>
  )
}

export default Menu
